export const common = {
  news: 'News',
  docs: 'Developers',
  en: 'EN',
  ko: 'KO',
  footer: '© Nexon Korea Corporation All Rights Reserved.',
}
